<template>
  <div v-if="dataLoaded">
      <source_button></source_button>
      <div class="main-content container">
        <div class="row">
          <div class="col-12 col-lg-4">
            <div class="nav-left">
              <div class="nav-header">
                <h2>BẠN ĐANG ĐỌC</h2>
              </div>
              <div v-if="!isLoggedIn()">
                <p>Mời đăng nhập để lưu truyện đang đọc</p>
              </div>
              <div v-else>
                <manga_list v-if="recentList.length != 0" 
                :mangas="recentList" 
                :isRecent="true" 
                @deleteClicked="deleteRecent"/>
                <p v-else>Bạn vẫn chưa đọc truyện nào nên chưa có lưu gì hết đâu bạn ơi</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-8">
            <manga_collection
              :title="mangaList[0].title" 
              :mangas="mangaList[0].data" 
              :horizontal="true" 
              v-observe-visibility="{
                callback: (isVisible, entry) => visibilityChanged(isVisible, 0),
                once: true  
              }"/>
            <manga_collection
              :title="mangaList[1].title" 
              :mangas="showFav ? mangaList[1].data : []" 
              :horizontal="true" 
              v-observe-visibility="{
                callback: (isVisible, entry) => visibilityChanged(isVisible, 1),
                once: true  
              }"/>
            <manga_collection
              :title="mangaList[2].title" 
              :mangas="showLatest ? mangaList[2].data : []" 
              :horizontal="true" 
              v-observe-visibility="{
                callback: (isVisible, entry) => visibilityChanged(isVisible, 2),
                once: true  
              }"/>
            <manga_collection
              :title="mangaList[3].title" 
              :mangas="showTopAll ? mangaList[3].data : []" 
              :horizontal="true" 
              v-observe-visibility="{
                callback: (isVisible, entry) => visibilityChanged(isVisible, 3),
                once: true  
              }"/>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import manga_collection from "@/components/manga-collection";
import { HTTP } from "../common/http-common";
import { ObserveVisibility } from "vue-observe-visibility";
import { bus } from '../main';
import recentMixins from "../common/recent-mixins"

export default {
  name: "Home",
  mixins: [recentMixins],
  directives: {
    ObserveVisibility
  },
  data() {
    return {
      dataLoaded: false,
      mangaList: [],
      recentList: [],
      showFav: false,
      showLatest: false,
      showTopAll: false
    }
  },
  components: {
    manga_collection: () => import("@/components/manga-collection"),
    source_button: () => import("@/components/source-button"),
    manga_list: () => import("@/components/manga-list")
  },
  methods: {
      getHomeData() {
          let source = this.source()
          let path = source + "_home/"
          HTTP.get(path)
            .then(response => {
                var recommend = response.data["recommend"];
                var favorite = response.data["favorite"];
                var latest = response.data["latest"];
                var topall = response.data["topall"];

                this.mangaList = [
                    { title: "Đề Xuất", data: recommend },
                    { title: "Yêu Thích", data: favorite },
                    { title: "Mới Cập Nhật", data: latest },
                    { title: "Xem Nhiều", data: topall }
                ]

                this.dataLoaded = true
                this.getRecentData().then(recents => {
                  this.recentList = recents
                })
            })
            .catch(e => {
                this.console.error(e);
            });
      },
      deleteRecent(manga) {
        this.deleteRecentData(manga)
          .then(response => {
            console.log(response.data)
            this.getRecentData().then(recents => {
              this.recentList = recents
            })
          })
      },
      visibilityChanged (isVisible, index) {
        if (isVisible) {
          switch (index) {
            case 1: 
              this.showFav = true
              break
            case 2: 
              this.showLatest = true
              break
            case 3: 
              this.showTopAll = true
              break
          }
        }
      }
  },
  created() {
    this.getHomeData()
    bus.$on('loggedOut', (_) => {
        console.log(_)
        this.getRecentData().then(recents => {
          this.recentList = recents
        })
    })
  },
  metaInfo() {
      return {
          title: "Đọc Truyện Online - Truyện Full - Nover - Hay Đọc Truyện - Truyện Convert - Truyện CV - Truyện Tranh",
          meta: [
              { name: 'description', content: 'Đọc truyện online, đọc truyện chữ, truyện hay, truyện convert, truyện tranh, truyện full. Nover luôn tổng hợp và cập nhật các chương truyện từ nhiều nguồn khác nhau một cách nhanh nhất. Đặc biệt có app đọc truyện cho di động.'},
              { property: 'og:title', content: "Đọc Truyện Online - Truyện Full - Nover - Hay Đọc Truyện - Truyện Convert - Truyện CV - Truyện Tranh"},
              { property: 'og:site_name', content: 'Đọc Truyện Online - Truyện Full - Nover - Hay Đọc Truyện - Truyện Convert - Truyện CV - Truyện Tranh'},
              { property: 'og:description', content: 'Đọc truyện online, đọc truyện chữ, truyện hay, truyện convert, truyện tranh, truyện full. Nover luôn tổng hợp và cập nhật các chương truyện từ nhiều nguồn khác nhau một cách nhanh nhất. Đặc biệt có app đọc truyện cho di động.'},
              { property: 'og:type', content: 'website'},
              { property: 'og:image', content: 'https://haydoctruyen.com/img/logo.b43c559b.webp'},
              { name: 'robots', content: 'index,follow'}
          ],
          link: [
              { rel: 'canonical', href: `${ this.$route.fullPath }`}
          ]
      }
  }
};
</script>
